import { Skeleton } from '@/components/atoms';
import { useUIColors } from '@/core/hooks';
import React from 'react';
import { StyleSheet, View } from 'react-native';

/**
 * Shimmer placeholder matching UnitActionCard (Book Appointment sidebar card).
 */
export function UnitActionCardSkeleton() {
  const colors = useUIColors();

  return (
    <View
      style={[styles.card, { backgroundColor: colors.backgroundLevel2 }]}
    >
      <View style={styles.header}>
        <Skeleton width={56} height={56} borderRadius={12} />
        <View style={styles.text}>
          <Skeleton width="70%" height={20} />
          <Skeleton width="100%" height={14} style={styles.line} />
          <Skeleton width="90%" height={14} style={styles.lineTight} />
        </View>
      </View>
      <Skeleton width="100%" height={44} borderRadius={8} />
    </View>
  );
}

const styles = StyleSheet.create({
  card: {
    borderRadius: 16,
    paddingTop: 16,
    paddingHorizontal: 16,
    paddingBottom: 12,
    gap: 24,
  },
  header: {
    flexDirection: 'row',
    gap: 16,
  },
  text: {
    flex: 1,
  },
  line: {
    marginTop: 8,
  },
  lineTight: {
    marginTop: 4,
  },
});

export default UnitActionCardSkeleton;
